import { render, staticRenderFns } from "./InventoriesTasks.vue?vue&type=template&id=37084b9f&scoped=true&"
import script from "./InventoriesTasks.vue?vue&type=script&lang=ts&"
export * from "./InventoriesTasks.vue?vue&type=script&lang=ts&"
import style0 from "./InventoriesTasks.vue?vue&type=style&index=0&id=37084b9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37084b9f",
  null
  
)

export default component.exports